<template>
  <div class="scroll-content">
    <div class="home" v-if="loaded">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8ce55b31827e79a05f48ab282530a893.png"
        alt=""
      />
      <AppNavbar
        :placeholder="true"
        :options="options"
        :zIndex="20"
        :title="title"
      >
        <div slot="right" class="right-icon-content">
          <img
            class="switch-icon"
            @click="bindSwitchCup"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44a8b714f7c4e5c593fbbfcef4e79a10.png"
            alt=""
          />
          <span
            v-if="loaded"
            @click.stop="bindSet"
            class="set-btn iconfont icon-shezhi2"
            id="set-btn"
          ></span>
        </div>
      </AppNavbar>
      <SystemReminder
        :cupType="2"
        :data="showSystemReminder || showCalendarReminder"
      ></SystemReminder>
      <div class="container">
        <div class="space"></div>
        <div class="top">
          <div class="info">
            <div class="nickname">
              {{
                (drinkData &&
                  drinkData.userDetail &&
                  drinkData.userDetail.truename) ||
                ''
              }}
            </div>
            <div class="desc">{{ drinkData && drinkData.text }}</div>
          </div>
          <div class="count-down">
            <CountDown
              v-if="loaded && (systemReminder || showCalendarReminder)"
              class="next-tip"
              :data="colorList"
              :status="curPlanDrink"
              :curTime="curTime"
              @change="bindChangeCountDown"
            >
            </CountDown>
          </div>
        </div>
        <!-- 彩虹杯 -->
        <div class="rainbow-container">
          <div class="ml-container">
            <MlRulerNormal
              class="ml-ruler"
              :data="colorList"
              :max="cupSize"
              :limit="drinkData.waterTotal"
            >
            </MlRulerNormal>
          </div>
          <RainbowLineCupNormal :status="curDrink" :data="colorList">
          </RainbowLineCupNormal>
          <div class="rainbow-line">
            <RainbowLineNormal :data="colorList" :status="curDrink">
            </RainbowLineNormal>
          </div>
        </div>
        <!-- 打卡按钮 -->
        <div class="clock-container">
          <div class="clock-top">
            <div class="left">
              <div class="text">今日已喝水</div>
              <div>
                <span class="number">{{ drinkVolume }}</span
                ><span class="ml">ML</span>
              </div>
            </div>
            <div class="center">
              <div
                class="clock-btn"
                id="clock-btn"
                v-if="loaded"
                @click="bindDrink"
              >
                <div class="clock-shadow"></div>
                <img
                  class="clock-image clock-disabled"
                  v-if="disabledDrink"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_9"
                  alt=""
                />
                <img class="clock-image" v-else :src="cupBtnUrl" alt="" />
                <div
                  class="text"
                  v-html="full ? btnList[curDrink].text : '灌满<br/>水杯'"
                ></div>
              </div>
            </div>
            <div class="right">
              <div class="text" id="drink-target">我的喝水目标</div>
              <div>
                <span class="number">{{
                  (drinkData && drinkData.waterTotal) || '-'
                }}</span
                ><span class="ml">ML</span>
              </div>
            </div>
          </div>
          <!-- 资源位 -->
          <!--  <BannerText class="banner-component" :data="bannerTextList"></BannerText> -->
        </div>
      </div>
      <!-- 轮播图资源位 -->
      <van-swipe
        v-if="bannerImageList && bannerImageList.length"
        class="my-swipe"
        :autoplay="5000"
        :show-indicators="false"
      >
        <van-swipe-item
          v-for="(item, index) in bannerImageList"
          :key="index"
          @click="bindClickBanner(item)"
        >
          <img
            class="swipe-image"
            v-buried
            data-buried="BG_HESHUI_NORMAL_BANNER"
            :data-eventv="'BG_HESHUI_NORMAL_BANNER_' + item.id"
            v-clickBuried
            data-click-buried="CLICK_HESHUI_NORMAL_BANNER"
            :data-click-eventv="'CLICK_HESHUI_NORMAL_BANNER_' + item.id"
            :src="item.img"
            alt=""
          />
        </van-swipe-item>
      </van-swipe>
      <!-- 喝水记录 -->
      <DrinkRecord
        class="drink-record"
        :data="drinkRecord"
        :cupType="2"
      ></DrinkRecord>
      <!-- 弹框 -->
      <MyToast
        :options="toastOptions"
        v-model="showToast"
        @confirm="bindConfirm"
        @cancel="bindCancel"
      ></MyToast>
      <TutorialTip
        v-model="tutorialData.showTutorial"
        @click="bindNextTip"
        :options="tutorialData.tipsOptions"
      >
      </TutorialTip>
      <PosterComponent
        v-model="showPoster"
        :data="drinkData"
        :curTime="curTime"
        @comfirm="bindHidePoster"
      >
      </PosterComponent>
    </div>
    <HomeLoading v-if="!loaded"></HomeLoading>
    <DisableWebview></DisableWebview>
    <FullCup
      v-model="showFullCup"
      :title="tutorialTitle"
      @click="bindFullCup"
      :cupType="2"
    ></FullCup>
  </div>
</template>
<script>
import MlRulerNormal from '../components/ml-ruler-normal.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import RainbowLineNormal from '../components/rainbow-line-normal.vue'
import DrinkRecord from '../components/drink-record.vue'
import MyToast from '../components/toast.vue'
import RainbowLineCupNormal from '../components/rainbow-cup-normal.vue'
import TutorialTip from '../components/tutorial.vue'
import PosterComponent from '../components/poster-normal.vue'
import CountDown from '../components/countdown.vue'
import SystemReminder from '../components/system-reminder.vue'
import BannerText from '../components/banner-text.vue'
import HomeLoading from '../components/home-loading.vue'
import DisableWebview from '../components/disable-webview.vue'
import FullCup from '../components/full-cup.vue'
import { config, Calendar, getTimeArr, switchCalendar } from '../data'
import { Howl, Howler } from 'howler'
import { mapState } from 'vuex'
import {
  tipsStepList,
  shadowList,
  btnList,
  fullCupDailyTips,
  fullCupFirstTips,
  drinkSuccessHtml
} from '../data'
import { deepClone } from '@/common/common.js'
export default {
  name: 'drink-water-reminder-normal-index',
  components: {
    AppNavbar,
    MlRulerNormal,
    RainbowLineNormal,
    DrinkRecord,
    MyToast,
    RainbowLineCupNormal,
    TutorialTip,
    PosterComponent,
    CountDown,
    SystemReminder,
    BannerText,
    HomeLoading,
    DisableWebview,
    FullCup
  },
  data() {
    return {
      animationTime: config.anmationTime,
      tipsStepList: deepClone(tipsStepList),
      fullCupDailyTips: deepClone(fullCupDailyTips),
      fullCupFirstTips: deepClone(fullCupFirstTips),
      loaded: false,
      title: '喝水提醒',
      options: {
        barBackgroundColor: 'transparent'
      },
      unifyId: '', //用户id
      showToast: false, //是否显示信息弹框
      toastOptions: {
        showCancelButton: true,
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_err_icon_3',
        imageTop: '-80px',
        title: '标题',
        message: '喝水'
      }, //信息弹框的数据参数
      showPoster: false, //显示海报
      colorList: [],
      shadowList: shadowList, //喝水按钮的阴影列表
      curPlanDrink: 10, //当前计划喝水
      curDrink: 9,
      drinkVolume: '-', //今日已喝水量
      curTime: '',
      btnList: btnList,
      drinkRecord: [],
      cupSize: 2200, //水杯容量
      systemReminder: true, //是否开启了后台的系统通知
      showSystemReminder: true, //是否开启了后台的系统通知 用于显示隐藏顶部提示
      showCalendarReminder: true, //是否开启日历通知
      bannerTextList: [], //资源位数据
      bannerImageList: [],
      showFullCup: false,
      disabledOperate: false, //禁用操作
      canFullCupAnimation: false, //是否能执行装满水的动画
      tutorialTitle: '',
      showFirstCreatePlan: false,
      full: false, //水杯是否装满
      tutorialData: {
        showTutorial: false, //是否显示首次引导
        curTutorial: 0, // 当前显示的引导index
        tipsOptions: {}, //当前引导显示的数据参数
        tipsStepList: [] //首次引导文案列表
      },
      cupType: 2,
      cupBtnUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/667996abb523d60825c3f3113aeb224f.png' //普通杯按钮图片链接
    }
  },
  computed: {
    ...mapState('drinkWater', [
      'drinkData',
      'waterId',
      'needUpdate',
      'needUpdateCalendar'
    ]),
    disabledDrink() {
      return (
        this.curDrink < this.curPlanDrink ||
        this.curPlanDrink > this.colorList.length
      )
    }
  },
  created() {
    this.getBannerData()
    this.init()
  },
  activated() {
    if (this.needUpdate) {
      this.$store.commit('drinkWater/setNeedUpdate', false)
      this.$router.replace('/drink-water-reminder/generate')
      return
    }
    if (this.needUpdateCalendar) {
      this.$store.commit('drinkWater/setNeedUpdateCalendar', false)
      this.updateSystem()
    }
    if (this.loaded && this.drinkData && this.drinkData.list.length) {
      this.getSystemReminder(true, true)
    }
    this.bindCheckCalendar()
  },
  mounted() {
    //埋点 喝水提醒首页曝光
    this.$buryPoint('BG_WATER', {})
    document.addEventListener('scroll', this.bindScroll, { passive: false })
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.bindScroll, { passive: false })
  },
  methods: {
    updateSystem() {
      this.$http
        .postBaseApp('api/v2/WaterRemind/getMessageState', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            switchCalendar(this.drinkData.list)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    init() {
      this.getDrinkData()
      this.getDrinkRecord()
    },
    bindSwitchCup() {
      this.bindShowToast(
        {
          zIndex: 1000,
          title: '提示',
          message: '是否切换为彩虹杯？',
          showCancelButton: true
        },
        () => {
          this.switchCupType()
        }
      )
    },
    //切换彩虹杯类型
    switchCupType() {
      let params = {
        use_version: 1
      }
      this.$http
        .postBaseApp('api/v2/WaterRemind/changeWaterVersion', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            switchCalendar(this.drinkData.list)
            setTimeout(() => {
              this.$router.replace('/drink-water-reminder/generate')
            }, 300)
          } else {
            this.$router.replace('/drink-water-reminder/start')
            this.$toast(res.msg)
          }
        })
    },
    //检查本地日历是否存在
    bindCheckCalendar() {
      Calendar.allowCalendar()
        .then(() => {
          Calendar.getCalendarList()
            .then((res) => {
              let list = res.data
              if (list && Array.isArray(list)) {
                let hasCalendar = false
                for (let i = 0; i < list.length; i++) {
                  if (list[i].name == Calendar.calendarName) {
                    hasCalendar = true
                    break
                  }
                }
                this.showCalendarReminder = hasCalendar
              } else {
                this.showCalendarReminder = false
              }
            })
            .catch((err) => {
              this.showCalendarReminder = false
            })
        })
        .catch(() => {
          this.showCalendarReminder = false
        })
    },
    //请求接口去装满水
    bindFullCup() {
      this.disabledOperate = true
      this.sendFullCup()
    },
    sendFullCup() {
      this.$http
        .postBaseApp('api/v2/WaterRemind/fillUpWater', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.canFullCupAnimation = true
            this.getDrinkData(true)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.disabledOperate = false
        })
    },
    bindFullCupAnimation() {
      this.canFullCupAnimation = false
      setTimeout(() => {
        this.playFullCupSound()
      }, 500)
      setTimeout(() => {
        this.fullCupSound.stop()
        this.bindFullCupEnd()
      }, this.animationTime * 1000 * this.curDrink + 1000)
    },
    //装满之后执行的操作
    bindFullCupEnd() {
      this.disabledOperate = false
      this.full = true
      this.showFirstCreatePlan =
        localStorage.getItem('first-show-dirnk-plan-2') == '1'
      const list = this.showFirstCreatePlan
        ? this.fullCupDailyTips[2]
        : this.fullCupFirstTips[2]
      localStorage.setItem('first-show-dirnk-plan-2', '1')
      if (!this.showFirstCreatePlan) {
        list[0].text = list[0].text.replace(
          '<placeholder1>',
          this.drinkData.list[0].water_color
        )
        list[0].text = list[0].text.replace(
          '<placeholder2>',
          this.drinkData.list[0].color_name
        )
      }
      this.setTutorial(list, this.getShowTutorial)
    },
    loadFullSound() {
      this.fullCupSound = new Howl({
        src: [
          'https://gymvue.gymcity.com.cn/betterwe_app/fillcup.mp3'
        ],
        autoplay: true,
        loop: true
      })
    },
    loadDrinkSound() {
      this.drinkSound = new Howl({
        src: [
          'https://gymvue.gymcity.com.cn/betterwe_app/drink.mp3'
        ],
        autoplay: true,
        loop: false
      })
    },
    //播放装满水杯音效
    playFullCupSound() {
      this.fullCupSound.play()
    },
    //播放喝水音效
    playDrinkSound() {
      this.drinkSound.play()
    },
    //获取是否开启系统提醒
    getSystemReminder(updateTips, showToast) {
      this.$http
        .postBaseApp('api/v2/WaterRemind/getMessageState', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.systemReminder = !!res.data.generic_is_open_system
            if (updateTips) {
              this.showSystemReminder = this.systemReminder
            }
            if (!this.systemReminder && showToast) {
              setTimeout(() => {
                this.showSystemToast()
              }, 500)
            }
          }
        })
        .catch(() => {})
    },
    //改变系统提醒
    changeSystemReminder() {
      let params = {
        water_user_id: this.waterId,
        sys_open: 1
      }
      this.$http
        .postBaseApp('api/v2/WaterRemind/editMessagePush', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.systemReminder = true
            this.showSystemReminder = true
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.allowLoading = false
        })
        .finally(() => {
          setTimeout(() => {
            this.bindShowCalendarReminder()
          }, 500)
        })
    },
    bindConfirm() {},
    showSystemToast() {
      let storage = localStorage.getItem('drink-common-reminder-2')
      if (!storage || storage == '0') {
        localStorage.setItem('drink-common-reminder-2', '1')
        this.bindShowToast(
          {
            imageTop: '-29vw',
            zIndex: 99,
            imageWidth: 295,
            imageHeight: 192,
            messageAlign: 'left',
            image:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b3ef1c5791e347d7d009102dd07c2a4d.png',
            title: '喝水变美挑战',
            message: `只有正确喝水，才能真的变美，希望你已经做好变美的准备，请<span style="color:rgba(98, 54, 255, 1)">接受喝水变美挑战</span>
            吧，期间我们会严格按钮您的定制喝水方案定时提醒您喝水，一起坚持，一起变美吧！`,
            confirmButtonText: '接受挑战'
          },
          this.changeSystemReminder,
          this.cancelSystemReminder
        )
      }
    },
    //显示日历通知
    bindShowCalendarReminder() {
      //鸿蒙端隐藏日历提醒弹窗
      if (this.$betterwe.isHarmony()) {
        return
      }
      Calendar.allowCalendar()
        .then(() => {
          this.bindShowToast(
            {
              imageTop: '-29vw',
              zIndex: 99,
              imageWidth: 295,
              imageHeight: 192,
              messageAlign: 'left',
              image:
                'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b3ef1c5791e347d7d009102dd07c2a4d.png',
              title: '友情提醒',
              message: `为了能准时提醒大家喝水，<span style="color:rgba(98, 54, 255, 1)">betterWE会和您的系统日历做链接，在「日历」中加入提醒日程</span>若不想和日历关联，请在此页面手动关闭相关的提醒选项。`,
              confirmButtonText: '允许日历通知',
              showCancelButton: true,
              cancelButtonText: '不允许'
            },
            this.bindSetCalendar
          )
        })
        .catch(() => {})
    },
    //设置日历
    bindSetCalendar() {
      let params = {
        water_user_id: this.waterId,
        day_open: 1
      }
      this.$http
        .postBaseApp('api/v2/WaterRemind/editMessagePush', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let timeArr = getTimeArr(this.drinkData.list)
            Calendar.setCalendar(timeArr)
              .then((res) => {
                this.$toast('开启成功')
              })
              .catch(() => {
                this.$toast('开启失败')
              })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //取消后台通知
    cancelSystemReminder() {
      this.showSystemReminder = false
      setTimeout(() => {
        this.bindShowCalendarReminder()
      }, 500)
    },
    //是否能马上喝水打卡
    canClock() {
      let time = 5000
      if (this.delayDrink) {
        this.bindShowToast({
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3bb57ad544cb0f431fc1531c87752514.png',
          imageWidth: 83,
          imageHeight: 77,
          title: '提示',
          message: '喝水太快啦，请休息一下哦!'
        })
        return false
      }
      this.delayDrink = true
      this.delayDrinkTimer = setTimeout(() => {
        this.delayDrink = false
      }, time)
      return true
    },
    //喝水
    bindDrink() {
      if (this.disabledOperate) {
        return
      }
      if (this.curDrink <= 0) {
        console.log('喝完了')
        this.bindShare()
        return
      }
      if (this.curDrink < this.curPlanDrink) {
        console.log('当前不能喝水')
        this.bindShowToast({
          imageWidth: 83,
          imageHeight: 77,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3bb57ad544cb0f431fc1531c87752514.png',
          title: '当前暂未到饮水时间',
          confirmButtonText: '我知道啦',
          message: '请在对应时间再来打卡哦！<br/>合理的饮水时间更有利于健康～'
        })
        return
      }
      if (!this.canClock()) {
        return
      }
      this.loadDrinkSound()
      let item = this.colorList[this.colorList.length - this.curDrink]
      let params = {
        water_user_id: this.waterId,
        water_record_id: item.id
      }
      this.$http
        .postBaseApp('api/v2/WaterRemind/genericWaterClock', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.updateDrinkData()
            this.getDrinkRecord()
            this.playDrinkSound()
            let text = drinkSuccessHtml
            let title = `您喝掉了<span style='font-size: 16px;font-weight: 600;color: #6236FF;margin:0 4px'>${item.water_volume}</span>ml的水`
            text = text.replace(/{{}}/, title)
            text = text.replace(/{{}}/, res.data)
            this.bindShowToast(
              {
                image:
                  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a3caa067c1a05483bb6ec559b6fc90f6.png',
                imageTop: '-80px',
                imageWidth: 295,
                imageHeight: 154,
                title: '喝水打卡成功！',
                message: text
              },
              this.bindShowShare
            )
          } else {
            if (res.code == 400 && res.data.code == -3) {
              this.bindShowToast({
                image:
                  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3bb57ad544cb0f431fc1531c87752514.png',
                imageWidth: 83,
                imageHeight: 77,
                title: '当前暂未到该色格饮水时间',
                confirmButtonText: '我知道啦',
                message:
                  '请在对应时间再来打卡哦！<br/>合理的饮水时间更有利于健康～'
              })
            } else {
              this.$toast(res.msg)
            }
          }
        })
    },
    bindShowShare() {
      if (this.curDrink <= 0) {
        this.bindShare()
      }
    },
    //获取喝水记录
    getDrinkRecord() {
      this.$http
        .postBaseApp('api/v2/WaterRemind/getGenericWaterClockRecord', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.drinkRecord = res.data
          }
        })
    },
    bindShowToast(options, confirmCallback, cancelCallback) {
      if (typeof confirmCallback == 'function') {
        this.bindConfirm = confirmCallback
      } else {
        this.bindConfirm = () => {}
      }
      if (typeof cancelCallback == 'function') {
        this.bindCancel = cancelCallback
      } else {
        this.bindCancel = () => {}
      }
      this.toastOptions = options
      this.showToast = true
    },
    bindCancel() {},
    bindHideToast() {
      this.showToast = false
    },
    //去设置界面
    bindSet() {
      if (this.disabledOperate) {
        return
      }
      this.$router.push('/drink-water-reminder/normal/set')
    },
    //去分享
    bindShare() {
      this.showPoster = true
    },
    bindHidePoster() {
      this.showPoster = false
    },
    getShowTutorial(len) {
      len = len || this.drinkData.list.length
      let list = this.tipsStepList[2]
      list[0].text = '根据您的喝水目标，<br/>我们每日将进行' + len + '次提醒'
      let storage = localStorage.getItem('drink-tutorial-2')
      if (!storage || storage == '0') {
        localStorage.setItem('drink-tutorial-2', '1')
        if (this.showFirstCreatePlan) {
          let func = () => {
            this.getSystemReminder(false, true)
          }
          this.setTutorial(list, func)
        } else {
          let func = () => {
            this.setFirstPlan()
          }
          this.setTutorial(list, func)
        }
      } else {
        this.getSystemReminder(true, true)
      }
    },
    setFirstPlan() {
      this.$http
        .postBaseApp('member/WaterClock/updateUserWaterState', {})
        .then((res) => {})
        .finally(() => {
          this.getSystemReminder(false, true)
        })
    },
    //设置引导数据 引导数据, 引导完成后的回调函数
    setTutorial(list, callback) {
      if (!Array.isArray(list) || list.length <= 0) {
        return
      }
      this.tutorialData.tipsStepList = list
      this.tutorialData.curTutorial = 0
      this.tutorialData.tipsOptions = list[this.tutorialData.curTutorial]
      if (typeof callback == 'function') {
        this.bindNextTipEnd = callback
      }
      this.tutorialData.showTutorial = true
    },
    //点击显示引导列表中的下一个提示
    bindNextTip() {
      this.tutorialData.curTutorial++
      if (this.tutorialData.tipsStepList[this.tutorialData.curTutorial]) {
        this.tutorialData.tipsOptions =
          this.tutorialData.tipsStepList[this.tutorialData.curTutorial]
      } else {
        this.tutorialData.showTutorial = false
        this.bindNextTipEnd()
      }
    },
    //引导完成时执行
    bindNextTipEnd() {},
    bindScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop <= 20) {
        this.options = {
          barBackgroundColor: 'transparent'
        }
      } else {
        this.options = {
          barBackgroundColor: '#fff'
        }
      }
      if (scrollTop < 0) {
        e.preventDefault()
      }
    },
    bindTouchMove(e) {
      let scrollTop = e.target.scrollTop
      console.log(e.target.documentElement)
      if (scrollTop < 0) {
        e.preventDefault()
      }
    },
    //计算当前用户喝到哪一格
    computeCurDrink(list) {
      let index = -1
      let drinkNum = 0
      for (let i = 0; i < list.length; i++) {
        if (list[i].drink_water) {
          index = i
          drinkNum += list[i].water_volume
        } else {
          break
        }
      }
      this.curDrink = list.length - 1 - index
      this.drinkVolume = drinkNum
    },
    //计算当前应该喝到哪里
    computePlanDrink(time, list) {
      let res = -1
      if (time) {
        let now = new Date(parseInt(time) * 1000)
        let hours = now.getHours()
        let minute = now.getMinutes()
        let second = now.getSeconds()
        //当日凌晨时间
        let curDayTime =
          now.getTime() -
          hours * (1000 * 60 * 60) -
          minute * (1000 * 60) -
          second * 1000
        for (let i = 0; i < list.length; i++) {
          let item = list[i].time_slot
          let cur = this.convertStrToTime(item, curDayTime)
          if (cur > now.getTime()) {
            break
          }
          res = i
        }
        if (res >= list.length - 1 && list[list.length - 1].drink_water) {
          res++
        }
      }
      res = list.length - res
      this.curPlanDrink = res
    },
    //将当日时间hh:mm转换成时间戳
    convertStrToTime(str, curDayTime) {
      let arr = str.split(':')
      let hours = parseInt(arr[0])
      let minute = parseInt(arr[1])
      let res = curDayTime + hours * 1000 * 60 * 60 + minute * (1000 * 60)
      return res
    },
    updateDrinkData() {
      let params = {
        water_user_id: this.waterId
      }
      this.$http
        .getBaseApp('api/v2/WaterRemind/getGenericWaterPlan', params)
        .then((res) => {
          res = res.data
          this.$store.commit('drinkWater/setDrinkData', res.data)
          this.computePlanDrink(res.time, res.data.list)
          this.computeCurDrink(res.data.list)
        })
    },
    //获取喝水信息
    getDrinkData() {
      let params = {
        water_user_id: this.waterId
      }
      let promise1 = this.$http.getBaseApp(
        'api/v2/WaterRemind/getGenericWaterPlan',
        params
      )
      let promise2 = this.$http.getBaseApp(
        'api/v2/WaterRemind/getWaterIsFull',
        {}
      )
      Promise.all([promise1, promise2])
        .then((resArr) => {
          let res = resArr[0].data
          let res1 = resArr[1].data
          if (res.code == 200 && res1.code == 200) {
            this.full = !!res1.data.code
            this.$store.commit('drinkWater/setDrinkData', res.data)
            this.tutorialTitle = res1.data.msg
            this.colorList = res.data.list
            this.curTime = res.time
            this.unifyId = res.data.userDetail.unifyId || ''
            this.tutorialData.tipsStepList = this.tipsStepList[2] //首次引导文案列表
            if (this.needUpdateCalendar) {
              this.$store.commit('drinkWater/setNeedUpdateCalendar', false)
              this.updateSystem()
            }
            if (this.full) {
              this.computePlanDrink(res.time, res.data.list)
              this.computeCurDrink(res.data.list)
            } else {
              this.curPlanDrink = 0
              this.curDrink = 0
            }
            !this.full &&
              this.$nextTick(() => {
                this.showFullCup = true
              })
            if (this.full && this.canFullCupAnimation) {
              this.loadFullSound()
              this.bindFullCupAnimation()
            } else if (this.full && !this.canFullCupAnimation) {
              setTimeout(() => {
                this.getShowTutorial()
              }, 500)
            }
            Calendar.updateCalendar(this.colorList)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((res) => {
          console.log(res)
          this.$toast('异常错误')
        })
        .finally(() => {
          this.loaded = true
        })
    },
    bindChangeCountDown() {
      if (this.curPlanDrink > 0) {
        this.curPlanDrink--
      }
    },
    //获取资源位信息
    getBannerData() {
      let params = {
        position_type: '23', //位置类型
        resource_type: '1' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.bannerImageList = res.data || []
          }
        })
        .catch((err) => {})
    },
    bindClickBanner(item) {
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.right-icon-content {
  display: inline-flex;
  align-items: center;
}

.share {
  font-size: 26px;
  color: rgba(0, 0, 0, 0.8);
  margin-right: 16px;
}

.switch-icon {
  display: inline-block;
  height: 32px;
  margin-right: 4px;
}

.set-btn {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.8);
  animation: myopacity 0.5s ease;
}

@keyframes myopacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.home {
  overflow: hidden;
  position: relative;
  z-index: 0;
  background-color: rgba(232, 245, 253, 1);

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: auto;
  }

  .drink-record {
    width: 335px;
    margin: 0 auto 16px;
  }

  .container {
    position: relative;
    z-index: 0;
    padding: 20px 20px 0px;
    box-sizing: border-box;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .info {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;

        .nickname {
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 28px;
          height: 28px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-bottom: 5px;
        }

        .desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          min-height: 20px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 20px;
        }
      }

      .next-tip {
        background: #ecf8ff;
        border-radius: 12px;
        backdrop-filter: blur(10px);
        padding: 13px 19px;
        box-sizing: border-box;
        text-align: center;
      }
    }

    .rainbow-container {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      height: 369px;
      margin-bottom: 20px;

      .ml-container {
        height: 295px;
      }

      .rainbow-line {
        height: 295px;
      }
    }

    /*  */
    .clock-container {
      padding: 7px 20px 16px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 12px;
      backdrop-filter: blur(10px);
      margin-bottom: 16px;

      .clock-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;

        .left {
          .text {
            white-space: nowrap;
            min-width: 85px;
            padding-bottom: 7px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
            border-bottom: 1px solid #dddddd;
            margin-bottom: 14px;
          }

          .number {
            font-size: 24px;
            font-family: DINCondensed-Bold, DINCondensed;
            color: #6236ff;
            height: 17px;
            display: inline-flex;
            align-items: center;
            margin-right: 3px;
          }

          .ml {
            font-size: 14px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #6236ff;
            line-height: 17px;
          }
        }

        .center {
          width: 100px;
          height: 100px;
          position: relative;

          .clock-btn {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 86px;
            height: 86px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100px;
            height: 100px;
            backface-visibility: hidden;
            transform: translate(-50%, -50%) translate3d(0, 0, 0);

            .clock-shadow {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              border-radius: 50%;
              overflow: hidden;
              background: #fdfdfd;
              box-shadow: none;
              animation: myscale 2s linear infinite;
              z-index: -2;
            }

            .clock-image {
              width: 100px;
              height: 100px;
              object-fit: contain;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              z-index: -1;
            }

            .text {
              width: 45px;
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #fff;
              line-height: 22px;
              letter-spacing: 1px;
              transform: translate3d(0, 0, 0);
            }
          }
        }

        .right {
          .text {
            white-space: nowrap;
            min-width: 85px;
            padding-bottom: 7px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
            border-bottom: 1px solid #dddddd;
            margin-bottom: 14px;
          }

          .number {
            font-size: 24px;
            font-family: DINCondensed-Bold, DINCondensed;
            color: rgba(0, 0, 0, 0.8);
            line-height: 17px;
            margin-right: 3px;
          }

          .ml {
            font-size: 14px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.8);
            line-height: 17px;
          }
        }
      }

      .banner-component {
        margin-top: 7px;
      }
    }
  }
}

.my-swipe {
  margin-bottom: 16px;

  .swipe-image {
    margin: 0 auto;
    width: 335px;
    height: 80px;
    object-fit: cover;
  }
}

.count-down {
  height: 70px;
}

.van-popup::v-deep {
  background-color: transparent;
}

@keyframes myscale {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.86);
  }

  100% {
    transform: scale(1);
  }
}
</style>
